import * as React from 'react';

import type { DialogContentProps as MUIDialogContentProps } from '@mui/material';
import { DialogContent as MUIDialogContent } from '@mui/material';

import { lookoDialogHeaderClassName } from './DialogHeader';

export interface DialogContentProps {
  /** 대화상자 본문에 표시할 구성 요소다. */
  children?: React.ReactNode;
  /** 기본 여백 뒤에 합성할 추가 스타일이다. */
  sx?: MUIDialogContentProps['sx'];
}

/**
 * 헤더와 인접할 때의 공통 여백을 적용한 대화상자 본문을 렌더링한다.
 *
 * @param props 본문 내용과 추가 스타일
 * @returns 공통 본문 여백이 적용된 대화상자 콘텐츠 영역
 */
export default function DialogContent({ children, sx }: DialogContentProps) {
  return (
    <MUIDialogContent
      sx={[
        {
          px: 4,
          [`:where(.${lookoDialogHeaderClassName}) + &`]: {
            paddingTop: 3,
            paddingBottom: 3,
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </MUIDialogContent>
  );
}
